import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Adiciona manipulador para clicks globais apenas ao conectar o primeiro controlador dropdown
    if (!window.dropdownClickHandler) {
      window.dropdownClickHandler = this.handleDocumentClick.bind(this);
      document.addEventListener("click", window.dropdownClickHandler);
    }

    // Garantir que o menu comece fechado
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden");
    }
  }

  disconnect() {
    // Remove o manipulador se for o último controlador dropdown
    const activeDropdowns = document.querySelectorAll(
      "[data-controller='dropdown']"
    );
    if (activeDropdowns.length <= 1) {
      document.removeEventListener("click", window.dropdownClickHandler);
      window.dropdownClickHandler = null;
    }
  }

  toggle(event) {
    event.stopPropagation();

    // Verifica se o menu vai abrir ou fechar
    const isOpening = this.menuTarget.classList.contains("hidden");

    // Fecha outros dropdowns que possam estar abertos
    const openDropdowns = document.querySelectorAll(
      "[data-dropdown-target='menu']:not(.hidden)"
    );
    openDropdowns.forEach((dropdown) => {
      if (dropdown !== this.menuTarget) {
        dropdown.classList.add("hidden");
      }
    });

    // Sempre fecha todos os nested dropdowns quando um dropdown principal é interagido
    this.closeAllNestedDropdowns();

    // Alterna a visibilidade do menu principal
    this.menuTarget.classList.toggle("hidden");
  }

  // Método para impedir propagação de cliques em elementos aninhados
  stopPropagation(event) {
    event.stopPropagation();
  }

  // Fecha todos os nested dropdowns
  closeAllNestedDropdowns() {
    const nestedDropdowns = document.querySelectorAll(
      "[data-nested-dropdown-target='menu']"
    );
    nestedDropdowns.forEach((menu) => {
      menu.classList.add("hidden");
    });
  }

  handleDocumentClick(event) {
    // Fecha todos os dropdowns quando clica fora
    const dropdownControllers = document.querySelectorAll(
      "[data-controller='dropdown']"
    );

    dropdownControllers.forEach((controller) => {
      // Verifica se o controller é esta instância
      const menu = controller.querySelector("[data-dropdown-target='menu']");
      if (
        menu &&
        !menu.classList.contains("hidden") &&
        !controller.contains(event.target)
      ) {
        menu.classList.add("hidden");

        // Também fecha nested dropdowns quando clica fora
        this.closeAllNestedDropdowns();
      }
    });
  }
}
